import React, { useState, useEffect } from "react"
import { animateScroll } from "react-scroll"

import * as s from "./SubHeader.module.scss"

import { Cta } from "../../common/cta/Cta"
import { Video } from "../../common/video/Video"
import { Interstital } from "../interstital/Interstital"

export const SubHeader = ({ data }) => {
  const [visible, setVisible] = useState(false)
  const [showInter, setShowInter] = useState(false)

  useEffect(() => {
    setVisible(true)
    setShowInter(true)
  }, [])

  const { blocks2, blurb, links, title, direction, scrollText } = data

  return (
    <div
      className={`${s.SubHeader} ${
        visible && !showInter ? s.SubHeader___visible : ""
      } ${direction === "RTL" ? s.SubHeader___rtl : ""}`}
    >
      {showInter && (
        <Interstital
          onEnd={() => {
            setShowInter(false)
          }}
        />
      )}
      <div className={s.Title}>
        <div className={s.Title__inner}>
          <h1
            className={s.Title__title}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <div
            className={s.Title__blurb}
            dangerouslySetInnerHTML={{ __html: blurb }}
          />

          <div className={s.Title__links}>
            <Cta
              title={scrollText}
              onClick={() => {
                animateScroll.scrollMore(window.innerHeight * 0.95)
              }}
            />

            {links &&
              links.map((item, i) => {
                return (
                  <Cta key={i} title={item.link.title} link={item.link.url} />
                )
              })}
          </div>
        </div>
      </div>

      <div className={s.Blocks}>
        {blocks2 &&
          blocks2.map((block, idx) => {
            if (block.type === "image") {
              if (!block.image) return <></>
              return (
                <div
                  role="image"
                  aria-label={block.image?.altText}
                  key={`image-${idx}`}
                  className={s.Blocks__block}
                  style={{
                    background: `url(${block.image.sourceUrl})`,
                  }}
                />
              )
            } else if (block.type === "video") {
              if (!block.videoUrl && !block.videoFile) return <></>

              return (
                <div
                  key={idx}
                  className={`${s.Blocks__block} ${s.Blocks__block___video}`}
                >
                  <Video
                    url={block.videoUrl || block.videoFile.sourceUrl}
                    hidePlayButton={true}
                  />
                </div>
              )
            } else if (block.type === "instagram") {
              return (
                <div
                  key={idx}
                  className={`${s.Blocks__block} ${s.Blocks__block___instagram}`}
                  style={{
                    background: block.image
                      ? `url(${block.image.sourceUrl})`
                      : "red",
                  }}
                >
                  <a
                    href={block.instagramLink}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className={s.Blocks__block___instagram__profile}>
                      <div
                        style={{
                          backgroundImage:
                            block.instagramProfileImage &&
                            `url(${block.instagramProfileImage.sourceUrl})`,
                        }}
                      />
                      <span>{block.instagramHandle}</span>
                    </div>
                  </a>
                </div>
              )
            }
          })}
      </div>
    </div>
  )
}
